/* ============
 * EDI Order Transformer
 * ============
 *
 * The transformer for the edi order.
 */

import Transformer from './transformer';
import moment from 'moment';

export default class EdiOrderTransformer extends Transformer {
  static fetch(ediOrder) {
    return {
      id: ediOrder.id,
      hashid: ediOrder.hashid,
      orderId: ediOrder.order_id,
      orderNumber: ediOrder.order_number,
      orderType: ediOrder.order_type,
      clientName: ediOrder.client_name,
      serviceName: ediOrder.service_name,
      totalValue: ediOrder.total_amount,
      totalQuantity: ediOrder.total_quantity,
      organizationId: ediOrder.organization_id,
      ediSupplierId: ediOrder.edi_supplier_id,
      ediBuyerId: ediOrder.edi_buyer_id,
      ediStoreId: ediOrder.edi_store_id,
      ediOrderStatusId: ediOrder.edi_order_status_id,
      ediOrderTypeId: ediOrder.edi_order_type_id,
      ediSupplierLocationId: ediOrder.edi_supplier_location_id,
      ediBuyerLocationId: ediOrder.edi_buyer_location_id,
      ediBuyerVatId: ediOrder.edi_buyer_vat_id,
      ediStorePartyId: ediOrder.edi_store_party_id,
      ediStoreName: ediOrder.edi_store_name,
      ediStoreStreet: ediOrder.edi_store_street,
      ediStorePostCode: ediOrder.edi_store_post_code,
      ediOrderTypeName: ediOrder.edi_order_type_name,
      ediOrderStatusName: ediOrder.edi_order_status_name,
      ediOrderNumber: ediOrder.edi_order_number,
      requestedDeliveryDate: ediOrder.requested_delivery_date ? moment(ediOrder.requested_delivery_date).format('DD.MM.Y') : null,
      // deliveryDate: ediOrder.delivery_date ? moment(ediOrder.delivery_date).format('DD.MM.Y') : null,
      // pickupDate: ediOrder.pickup_date ? moment(ediOrder.pickup_date).format('DD.MM.Y') : null,
      shippingProvider: ediOrder.shipping_provider,
      numberOfItems: ediOrder.number_of_items,
      ediOrderSource: ediOrder.edi_order_source,
      ediOrderSourceOrderId: ediOrder.edi_order_source_order_id,
      ediOrderSourceOrderNumber: ediOrder.edi_order_source_order_number,
      createdAt: ediOrder.created_at ? moment(ediOrder.created_at).format('D.M.Y') : null,
      standard: ediOrder.standard,
      hasOrderConfirmation: ediOrder.has_order_confirmation,
    };
  }

  static send(ediOrder) {
    return {
      id: ediOrder.id,
      hashid: ediOrder.hashid,
      order_number: ediOrder.orderNumber,
      organization_id: ediOrder.organizationId,
      edi_supplier_id: ediOrder.ediSupplierId,
      edi_buyer_id: ediOrder.ediBuyerId,
      edi_store_id: ediOrder.ediStoreId,
      edi_order_status_id: ediOrder.ediOrderStatusId,
      edi_order_type_id: ediOrder.ediOrderTypeId,
      edi_supplier_location_id: ediOrder.ediSupplierLocationId,
      edi_buyer_location_id: ediOrder.ediBuyerLocationId,
      edi_buyer_vat_id: ediOrder.ediBuyerVatId,
      edi_store_party_id: ediOrder.ediStorePartyId,
      edi_store_name: ediOrder.ediStoreName,
      edi_store_street: ediOrder.ediStoreStreet,
      edi_store_post_code: ediOrder.ediStorePostCode,
      edi_order_type_name: ediOrder.ediOrderTypeName,
      edi_order_status_name: ediOrder.ediOrderStatusName,
      edi_order_number: ediOrder.ediOrderNumber,
      requested_delivery_date: ediOrder.requestedDeliveryDate ? moment(ediOrder.requestedDeliveryDate).format('Y-MM-DD HH:mm:ss') : null,
      delivery_date: ediOrder.deliveryDate ? moment(ediOrder.deliveryDate).format('Y-MM-DD HH:mm:ss') : null,
      discount: ediOrder.discount,
      number_of_items: ediOrder.numberOfItems,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/ediOrder.js